const pollingTimeoutRefs = {}
const pollingStartTimeRefs = {}
// One polling round per file: overlapping rounds each report 'completed' and duplicate downstream work
const activePollingRefs = new Set()
const clearPollingTimeout = (uuid) => {
  if (pollingTimeoutRefs[uuid]) {
    clearTimeout(pollingTimeoutRefs[uuid])
    delete pollingTimeoutRefs[uuid]
  }
}

export { activePollingRefs, pollingStartTimeRefs, pollingTimeoutRefs, clearPollingTimeout }
